// extracted by mini-css-extract-plugin
export default {"stylePageViewsContainer":"AssetListView-module--stylePageViewsContainer--1XUpP"};